/**
 * True on Mac, false everywhere else. The single source of truth for the
 * search shortcut: `PortalSearchModal`'s Cmd+K / Ctrl+K keybind and
 * `SidebarSearchTrigger`'s ⌘K / Ctrl+K badge both read it, so the binding and
 * the hint it advertises can't drift apart.
 *
 * `navigator.platform` is deprecated but still the most broadly supported way
 * to read the OS family; `userAgent` is the fallback for the odd browser that
 * has already dropped it.
 */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /Mac|iPod|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');
}
